import { useAbility } from "@/casl-provider";
import { useVehicleSnapshotDownloadMutation } from "@/common/api/vehicle/use-vehicle-snapshot-download.mutation";
import { useVehicleSnapshotQuery } from "@/common/api/vehicle/use-vehicle-snapshot.query";
import { DatSnapshotAction, type DatSnapshotTranslations } from "@/components/dat-snapshot/dat-snapshot-action";
import type { ButtonSize } from "@/components/ui/button";
import { VEHICLE_SNAPSHOT_SUBJECT } from "@/modules/masterdata/vehicle/vehicle-snapshot.permissions";
import { useTranslation } from "react-i18next";

interface VehicleSnapshotActionProps {
  className?: string;
  showInCommandPalette?: boolean;
  size?: ButtonSize;
  vehicleUuid: string;
}

export function VehicleSnapshotAction({
  className,
  showInCommandPalette,
  size,
  vehicleUuid,
}: VehicleSnapshotActionProps) {
  const { t } = useTranslation("fab");
  const ability = useAbility();
  const translations: DatSnapshotTranslations = {
    description: t("VehicleDatSnapshotDescription"),
    downloadError: t("VehicleDatSnapshotDownloadError"),
    downloaded: t("VehicleDatSnapshotDownloaded"),
    downloadLabel: t("DownloadVehicleDatSnapshot"),
    loadErrorDescription: t("VehicleDatSnapshotLoadErrorDescription"),
    loadErrorTitle: t("VehicleDatSnapshotLoadErrorTitle"),
    retryLoad: t("RetryDatSnapshotLoad"),
    title: t("VehicleDatSnapshotTitle"),
    unavailableDescription: t("VehicleDatSnapshotUnavailableDescription"),
    unavailableTitle: t("VehicleDatSnapshotUnavailableTitle"),
    viewLabel: t("ViewVehicleDatSnapshot"),
  };

  return (
    <DatSnapshotAction
      canReadSnapshot={ability.can("read", VEHICLE_SNAPSHOT_SUBJECT)}
      className={className}
      showInCommandPalette={showInCommandPalette}
      size={size}
      snapshotUuid={vehicleUuid}
      translations={translations}
      useSnapshotDownloadMutation={useVehicleSnapshotDownloadMutation}
      useSnapshotQuery={useVehicleSnapshotQuery}
    />
  );
}
